import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { useT } from '../i18n';

const CONTACT_EMAIL = 'anabatalbook@gmail.com';
const WHATSAPP_LINK = 'https://wa.me/972505020178';
const YEAR = new Date().getFullYear();

export default function Footer() {
  const t = useT();
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <span className="site-footer-name">{t.appTitle}</span>
          <p className="site-footer-tagline">{t.footerTagline}</p>
        </div>

        <nav className="site-footer-col" aria-label={t.footerExploreTitle}>
          <span className="site-footer-col-title">{t.footerExploreTitle}</span>
          <Link to="/how-it-works" className="site-footer-link">{t.footerHowItWorks}</Link>
          <Link to="/therapeutic-approach" className="site-footer-link">{t.footerTherapeutic}</Link>
          {/* Server-rendered blog (Express route) — plain anchor, not a SPA Link. */}
          <a href="/blog" className="site-footer-link">{t.footerBlog}</a>
          <Link to="/terms" className="site-footer-link">{t.footerTerms}</Link>
        </nav>

        <div className="site-footer-col">
          <span className="site-footer-col-title">{t.footerContactTitle}</span>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer-contact site-footer-contact-whatsapp"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M19.11 4.91A9.82 9.82 0 0 0 12.04 2C6.6 2 2.18 6.42 2.18 11.86c0 1.74.46 3.43 1.32 4.93L2.1 22l5.36-1.4a9.83 9.83 0 0 0 4.58 1.16h.01c5.43 0 9.86-4.42 9.86-9.86 0-2.64-1.03-5.12-2.8-6.99zM12.04 20.1h-.01a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3.18.83.85-3.1-.2-.32a8.19 8.19 0 0 1-1.26-4.34c0-4.53 3.69-8.21 8.22-8.21 2.2 0 4.26.85 5.81 2.41a8.16 8.16 0 0 1 2.4 5.81c0 4.52-3.69 8.21-8.21 8.21zm4.5-6.15c-.25-.12-1.46-.72-1.69-.8-.23-.08-.39-.12-.55.12-.16.25-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.12-1.04-.38-1.98-1.22-.73-.65-1.22-1.45-1.37-1.7-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42l-.47-.01a.9.9 0 0 0-.65.31c-.22.25-.86.84-.86 2.05 0 1.21.88 2.37 1 2.54.12.16 1.74 2.66 4.21 3.73.59.25 1.05.4 1.4.52.59.19 1.13.16 1.55.1.47-.07 1.46-.6 1.67-1.18.2-.58.2-1.07.14-1.18-.06-.11-.22-.18-.47-.3z"/>
            </svg>
            {t.footerWhatsApp}
          </a>
          <a href={`mailto:${CONTACT_EMAIL}`} className="site-footer-contact">
            <Mail size={18} aria-hidden="true" />
            {CONTACT_EMAIL}
          </a>
          <a
            href="https://www.tiktok.com/@anabatal.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer-contact"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.29 0 .57.05.83.13V9.4a6.33 6.33 0 0 0-1-.08A6.34 6.34 0 0 0 5.3 20.1a6.34 6.34 0 0 0 10.86-4.43V8.65a8.16 8.16 0 0 0 4.77 1.52V6.69h-1.34z"/>
            </svg>
            TikTok
          </a>
          <a
            href="https://www.instagram.com/anabatal.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer-contact"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.72 3.72 0 0 1-1.38-.9 3.72 3.72 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63a5.88 5.88 0 0 0-2.13 1.38A5.88 5.88 0 0 0 .63 4.14C.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.79.73 1.46 1.38 2.13a5.88 5.88 0 0 0 2.13 1.38c.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.88 5.88 0 0 0 2.13-1.38 5.88 5.88 0 0 0 1.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.88 5.88 0 0 0-1.38-2.13A5.88 5.88 0 0 0 19.86.63c-.76-.3-1.64-.5-2.91-.56C15.67.01 15.26 0 12 0zm0 5.84A6.16 6.16 0 1 0 18.16 12 6.16 6.16 0 0 0 12 5.84zm0 10.16A4 4 0 1 1 16 12a4 4 0 0 1-4 4zm6.41-11.85a1.44 1.44 0 1 0 1.44 1.44 1.44 1.44 0 0 0-1.44-1.44z"/>
            </svg>
            Instagram
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61589801214611"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer-contact"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
              <path d="M22 12.06C22 6.51 17.52 2 12 2S2 6.51 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.78-3.91 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.88h2.78l-.44 2.91h-2.34V22c4.78-.79 8.43-4.94 8.43-9.94z"/>
            </svg>
            Facebook
          </a>
        </div>
      </div>

      <p className="site-footer-copy">© {YEAR} {t.appTitle} — {t.footerRights}</p>
    </footer>
  );
}
